import React, { useState } from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert2";

// Hay foto si urlFoto es una URL (el modelo trae "No" por omisión)
export const tieneFoto = (url) => typeof url === "string" && /^https?:\/\//.test(url);

// Cloudinary: pide la imagen ya recortada al tamaño que se va a mostrar
const recorte = (url, px) => (url.includes("/upload/") ? url.replace("/upload/", `/upload/c_fill,g_auto,w_${px},h_${px},q_auto,f_auto/`) : url);

const GRANDE = 260; // tamaño de la vista al pasar el cursor

// Foto cuadrada de un modelo: al pasar el cursor se ve grande; al tocarla (ampliar) se abre completa.
// Sin foto: ícono de prenda.
function FotoModelo({ url, nombre = "", size = 40, ampliar = true }) {
  const [vista, setVista] = useState(null); // { top, left } de la vista grande
  const base = { width: size, height: size, borderRadius: Math.round(size / 5), flex: "none", border: "1px solid #e2e8f0", background: "#f8fafc" };
  if (!tieneFoto(url)) {
    return (
      <div style={{ ...base, display: "flex", alignItems: "center", justifyContent: "center", color: "#cbd5e1", fontSize: Math.round(size * 0.45) }} title="Sin foto">
        <i className="fas fa-tshirt" />
      </div>
    );
  }
  const mostrar = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const alto = GRANDE + (nombre ? 30 : 0);
    // A la derecha de la miniatura; si no cabe, a la izquierda. Siempre dentro de la ventana.
    const left = r.right + 12 + GRANDE < window.innerWidth ? r.right + 12 : Math.max(8, r.left - GRANDE - 12);
    const top = Math.min(Math.max(8, r.top + r.height / 2 - alto / 2), window.innerHeight - alto - 8);
    setVista({ top, left });
  };
  const ver = (e) => {
    if (!ampliar) return;
    e.stopPropagation();
    setVista(null);
    Swal.fire({ imageUrl: url, imageAlt: nombre, title: nombre || undefined, showConfirmButton: false, showCloseButton: true, width: 560 });
  };
  return (
    <>
      <img src={recorte(url, size * 2)} alt={nombre} loading="lazy" onClick={ver} onMouseEnter={mostrar} onMouseLeave={() => setVista(null)}
        style={{ ...base, objectFit: "cover", cursor: ampliar ? "zoom-in" : "default" }} />
      {vista && ReactDOM.createPortal(
        <div style={{ position: "fixed", top: vista.top, left: vista.left, zIndex: 3000, pointerEvents: "none", background: "#fff", borderRadius: 14, padding: 6, boxShadow: "0 12px 40px rgba(15,23,42,.25)", border: "1px solid #e2e8f0" }}>
          <img src={recorte(url, GRANDE * 2)} alt="" style={{ width: GRANDE, height: GRANDE, objectFit: "cover", borderRadius: 10, display: "block" }} />
          {nombre && <div style={{ fontSize: "0.78rem", fontWeight: 600, color: "#0f172a", padding: "6px 4px 2px", maxWidth: GRANDE, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{nombre}</div>}
        </div>,
        document.body
      )}
    </>
  );
}

export default FotoModelo;
